<app-s01-navigation></app-s01-navigation>
<main class="browse-titles-page" #browseTitlesRef>
  <app-a04-picture-element
    width="1920"
    height="1080"
    webpSrcset="{{ '/assets/images/background/background-light.webp' | assetpipe }}"
    defaultSrc="{{ '/assets/images/background/background-light.jpg' | assetpipe }}"
    alt=""
    class="browse-title-background"
  >
  </app-a04-picture-element>
  <app-c01-tv-frame customClass="page-tv-frame" [hasBlackOverlay]="false">
    <app-c07-tv-intro-screen></app-c07-tv-intro-screen>
    <div class="tv-sliders-wrapper">
      <app-c08-browse-titles-slider
        *ngFor="let slider of slidersData"
        (sliderHeight)="setC08SliderHeight($event)"
        [sliderTitle]="slider.title"
        [movieTiles]="slider.slides"
        [isActive]="slider.isActive"
        [activeIndex]="slider.activeIndex"
      ></app-c08-browse-titles-slider>
    </div>
  </app-c01-tv-frame>
  <app-c02-remote-control-buttons
    [tooltipCopy]="showSecondTooltip ? currentStep.secondTooltipCopy : currentStep.tooltipCopy"
    [featureName]="featureName"
    [stepIndex]="stepIndex"
    [buttons]="
      availableControlButtons.length ? availableControlButtons : currentStep.activeButtonKeys
    "
    [disabled]="isRemoteDisabled"
  ></app-c02-remote-control-buttons>
  <app-c04-opening-screen [featureName]="featureName"></app-c04-opening-screen>
  <app-c06-end-screen [featureName]="featureName"></app-c06-end-screen>
  <app-a03-disclaimer-paragraph [featureName]="featureName"></app-a03-disclaimer-paragraph>
  <app-a05-custom-cta></app-a05-custom-cta>
  <app-c03-question-mark-modal [featureName]="featureName"></app-c03-question-mark-modal>
</main>
